import React, { useEffect } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import VerticalPage from '../../components/VerticalPage';
import tracker from '../../utils/tracker';
import gtmInitializer from '../../utils/gtmInitializer';

interface AppInitialProps {
    verticalSlug: VerticalSlugType;
    vertical: IVertical;
    isBusiness: boolean;
    dataLayerObject: DataLayerObjectType;
}

const App = ({ vertical, verticalSlug, isBusiness, dataLayerObject }: AppInitialProps) => {
    useEffect(() => {
        const { userId } = getContext();
        const isLoggedIn = !!userId;

        gtmInitializer(dataLayerObject);
        tracker.initialize(vertical);
        tracker.view(verticalSlug, isLoggedIn);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (vertical) {
        return <VerticalPage verticalData={vertical} isBusiness={isBusiness} />;
    } else {
        return 'Ops Page'; // TODO
    }
};

export default App;
